// React-scripts will only include environment variables starting with VITE
const {
  VITE_VERSION,
  VITE_BACKEND_URL,
  VITE_AUTH0_AUDIENCE,
  VITE_AUTH0_DOMAIN,
  VITE_AUTH0_CLIENT_ID,
  VITE_ENV,
  VITE_SENTRY_DSN,
  VITE_IFRAME_PARENT_WHITELIST,
  VITE_IFRAME_CHILD_URL,
  VITE_SPA_MODE,
  VITE_MICROFRONTEND_URL_PREFIX,
  VITE_DISABLE_SENTRY,
  VITE_DISABLE_AXE_CORE,
  VITE_ENABLE_REACT_QUERY_DEVTOOLS,
} = import.meta.env;

const STANDALONE = 'standalone';

/**
 * During the build process, webpack will (as specified in craco.config.js)
 * replace this with a string literal. In the code it can be treated much like a
 * normal global, hence the declaration.
 *
 * When runnings tests, jest does not compile the code and does a sort of JIT
 * transpilation on the typescript. In this case it will actually be a global
 * variable. It is analogous to a global variable: In the uncompiled typescript
 */
declare let VITE_GIT_COMMIT_HASH: string;

// BUILDKITE_COMMIT can be used in the CI pipeline, but won't work in local dev.
// Instead we define our own in vite.
// TODO: Something similar for frontendVersion, maybe involving git tags?
export const frontendCommitHash =
  process.env.NODE_ENV === 'test' ? 'thisisahash' : VITE_GIT_COMMIT_HASH;
export const frontendVersion = VITE_VERSION;

export const backendURL = VITE_BACKEND_URL;
export const auth0Domain = VITE_AUTH0_DOMAIN || '';
export const auth0ClientId = VITE_AUTH0_CLIENT_ID || '';
export const auth0Audience = VITE_AUTH0_AUDIENCE || '';
export const environment = process.env.NODE_ENV === 'test' ? 'test' : VITE_ENV || '';
export const sentryDsn = VITE_SENTRY_DSN;
export const iframeParentWhiteList = VITE_IFRAME_PARENT_WHITELIST?.split(',') || '';
export const iframeChildURL = VITE_IFRAME_CHILD_URL || '';
export const spaMode = VITE_SPA_MODE ?? STANDALONE;
export const microfrontendURLPrefix =
  spaMode === STANDALONE ? '' : VITE_MICROFRONTEND_URL_PREFIX || '';
export const isSentryDisabled = VITE_DISABLE_SENTRY === 'true';
export const isAxeCoreDisabled = VITE_DISABLE_AXE_CORE === 'true';
export const isReactQueryDevtoolsEnabled = VITE_ENABLE_REACT_QUERY_DEVTOOLS === 'true';

export const sentryFeedbackConfig = {
  autoInject: false,
  buttonLabel: 'Give feedback',
  colorScheme: 'light' as 'light' | 'dark' | 'system' | undefined,
  formTitle: 'Give feedback',
  isNameRequired: true,
  isEmailRequired: true,
  messagePlaceholder: "What's on your mind?",
  showBranding: false,
  submitButtonLabel: 'Give feedback',
  themeLight: {
    outline: 'rgba(0, 114, 54, 1)',
    accentBackground: 'rgba(0, 114, 54, 1)',
    successColor: '#007236',
    errorColor: '#d32f2f',
  },
};

// Environment-dependent variables
export const electionFilterMonthsInPast = environment === 'prod' ? 3 : 12;
export const maxTimeBetweenDomainCodeCheckMs =
  environment === 'prod'
    ? 3 * 30 * 24 * 60 * 60 * 1000 // About 3 months
    : 5 * 60 * 1000; // 5 minutes
